module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e210323"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Henr_9781401686307_epub_c7.5_r1#d6e3",
      "id": "d7e3"
    }
  }, [_c('b', [_vm._v("CHAPTER 3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e210823"
    }
  }, [_c('span', [_c('span', {
    staticClass: "dcap2",
    attrs: {
      "id": "d14e715"
    }
  }, [_vm._v("W")]), _vm._v("ithout discussing it, they took Nic’s Crown Victoria. As she slid behind the steering wheel, Nic’s fingers hovered over the switches that activated the siren, the alternately flashing lights in the grill, the red-and-blue light bar in the rear window. Then she lifted her hand and put it back on the wheel. A friend not showing up for dinner didn’t qualify as an emergency.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e213523"
    }
  }, [_c('span', [_vm._v("At a red light she cut a sideways glance at Allison. Her friend’s eyes were closed, her lips moving silently. Nic knew what she was doing. Offering up a prayer for Cassidy’s safety. The old Nic would have rolled her eyes at Allison’s gullibility. But that was before breast cancer had shown her just how impossible it sometimes was to stand only on your own two feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e215823"
    }
  }, [_c('span', [_vm._v("Traffic was light. A second before the signal turned green, Nic was halfway across the intersection. She knew she was driving too fast. Tailgating. Switching lanes every few seconds. She cut off a young guy driving a white cube-shaped car, ignoring his rude gesture. Two blocks later they hit a speed bump so hard they were momentarily airborne, their teeth clacking together when they landed. Finally they were flying down the freeway toward downtown Portland. Five minutes later Nic took the off-ramp for Cassidy’s neighborhood.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e218923"
    }
  }, [_c('span', [_vm._v("Located in the shadow of one of Portland’s eleven bridges, Riverside Condominiums had been envisioned as the first stage in the redevelopment of an old industrial area. When Cassidy bought her condo a few years back, artist renderings had pictured the area filled with shops, restaurants, and bars. Most of those businesses had never materialized. Instead the area was filled with boarded-up former warehouses and light manufacturing plants that had been bought and gutted but never rehabbed.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e222324"
    }
  }, [_c('span', [_vm._v("With few cars parked on it, the street that led to the condominiums seemed unnaturally wide. Adding to Nic’s sense of unease, there wasn’t a soul in sight. In the fading light, the whole area looked deserted. Of course there was no one around, she scolded herself. That’s what this part of town always looked like.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e224524"
    }
  }, [_c('span', [_vm._v("When they reached Cassidy’s condo building, Nic drove down the ramp into the underground parking garage. As soon as she got out of the car, the hot air immediately wrapped her in a smothering blanket.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e226124"
    }
  }, [_c('span', [_vm._v("“Look.” Allison pointed. “There’s her car.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e226824"
    }
  }, [_c('span', [_vm._v("“So she’s here.” Nic should have felt relief, but she didn’t. She was aware of her Glock in its shoulder holster. She wore the gun everyplace except at home, and sometimes even there. She undid the button on her jacket.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e228524"
    }
  }, [_c('span', [_vm._v("They walked over to Cassidy’s car, heels clacking on concrete already veined with cracks, and bent down to peer inside. It was the same mess it always was—brightly colored suits still wrapped in dry cleaner’s plastic, red Netflix envelopes, a mascara tube or two or three, celebrity gossip magazines, and enough empty silver Diet Coke cans to fill a couple of cases.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e230824"
    }
  }, [_c('span', [_vm._v("“Maybe she forgot something and had to stop by her place to get it before dinner,” Allison suggested. “Or she spilled something on her clothes and had to change.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e232525"
    }
  }, [_c('span', [_vm._v("Nic didn’t answer. There was no point in speculating. They would find out soon enough. Something inside her was building a wall between her thoughts and her emotions.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e233825"
    }
  }, [_c('span', [_vm._v("While they waited for the elevator, Allison pressed the redial button on her phone. She held it to her ear for a long moment, then ended the call without speaking. Her lips thinned to a white line.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e235125"
    }
  }, [_c('span', [_vm._v("The doors opened on the fourth floor. The hall must have had some sort of air-conditioning, because it was slightly cooler than the elevator. A plant in a dark brown ceramic pot sat next to the silver doors. Even though it was fake, it looked like it was dying. Dust furred its sagging fabric leaves.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e237025"
    }
  }, [_c('span', [_vm._v("Nic knocked on Cassidy’s door. She and Allison were both silent, listening for music, for footsteps, for their friend’s voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e238025"
    }
  }, [_c('span', [_vm._v("Nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e238825"
    }
  }, [_c('span', [_vm._v("Allison pressed the redial button again. Through the door they heard the faint first few notes of a song turned ringtone.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e239825"
    }
  }, [_c('span', [_vm._v("Cassidy never went anywhere without her phone.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e240525"
    }
  }, [_c('span', [_vm._v("“She has to be in there.” Allison bit her lip.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e241225"
    }
  }, [_c('span', [_vm._v("“You don’t have a key, do you?” Nic asked, but Allison shook her head.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e242225"
    }
  }, [_c('span', [_vm._v("With luck, the manager lived on-site. Nic would flash her badge. She would talk fast. She would say whatever she needed to say to get him to open this door. As she was thinking this, she put her hand to the doorknob. In her fingers, the handle turned.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e244025"
    }
  }, [_c('span', [_vm._v("Her mind split in two. One part was yammering that it was a bad sign, a bad sign indeed, that Cassidy’s door was unlocked. The other, more rational part, the part that made her a good FBI agent, was thinking about fingerprints. If there were any, she had probably just obliterated them. Not that it was easy to lift prints from a doorknob. The twisting motion turned prints into long smears.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e246826"
    }
  }, [_c('span', [_vm._v("Allison’s eyebrows rose. “It’s unlocked?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e247526"
    }
  }, [_c('span', [_vm._v("Nic nodded. Cassidy could be absentminded. It was possible she’d been in a hurry to get home for whatever reason and had forgotten to lock the door. She was probably sick, Nic told herself. They’d find her huddled miserably in the bathroom or curled up on the bed. It would explain everything. The unlocked door, the unanswered phone, the missed meal.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e249826"
    }
  }, [_c('span', [_vm._v("With her toe she nudged the door open. Her mouth was suddenly dry. She moistened her lips with a tongue that felt like leather.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e250826"
    }
  }, [_c('span', [_vm._v("“Cassidy?” She waited. “Cassidy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e251526"
    }
  }, [_c('span', [_vm._v("Nothing. Nothing but silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e252326"
    }
  }, [_c('span', [_vm._v("Nic elbowed the door wider and they both stepped inside. The room was shadowed, the light from the windows melting into dusk. Allison made a move toward the light switch, but Nic laid a hand on her arm.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e254126"
    }
  }, [_c('span', [_vm._v("“Fingerprints.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e254826"
    }
  }, [_c('span', [_vm._v("Allison’s eyes went wide, as if reality was just sinking in. Nic took a pen from her purse and flicked up the switch.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e255826"
    }
  }, [_c('span', [_vm._v("“Cassidy?” Allison called out again. “Cassidy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e256526"
    }
  }, [_c('span', [_vm._v("No answer. The word fell flat, absorbed by the willow green walls, the flat cream-colored Berber carpeting.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e257526"
    }
  }, [_c('span', [_vm._v("It was staggeringly hot. So hot and stale and close. Why hadn’t Cassidy turned on the air-conditioning? Why hadn’t she at least opened a window?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e258926"
    }
  }, [_c('span', [_vm._v("Without moving from the entryway, Nic turned her head, taking it all in. Cassidy’s mail had been tossed on the entryway table. Next to it were her keys and her black tote. A tall vase held a thick bouquet of tiny white flowers that smelled sickeningly sweet. A few of the blossoms had drifted down.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e260826"
    }
  }, [_c('span', [_vm._v("Nic thought of weddings, of flower girls in beribboned dresses, sprinkling pale petals before them. Of how Cassidy had had boyfriend after boyfriend but never married.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e262627"
    }
  }, [_c('span', [_vm._v("The white leather couch and matching armless chair in the living room were a sleek Danish design, with deep-seated cushions and steel legs. Nic couldn’t imagine sitting on leather in this heat. Let alone owning white furniture. It was the kind of furniture that only a woman without kids would buy. Between the couch and chair lay a curved smoked-glass table shaped like half a heart. The pedestal was made of twisted wood that looked tortured.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e265227"
    }
  }, [_c('span', [_vm._v("Nic sniffed. Nothing. No smells, no sounds, nothing unusual to see. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e265727"
    }
  }, [_c('span', [_vm._v("Her nerves thrummed. Something working below the level of consciousness was screaming at her to run.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e266727"
    }
  }, [_c('span', [_vm._v("“It’s a little messy.” Allison swept out one arm to indicate the room, the pair of pumps kicked off in front of the couch, the book left facedown on the chair. Her voice shook a little bit. “But no messier than any of the other times I’ve seen it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e268327"
    }
  }, [_c('span', [_vm._v("“If anything, I’d say it’s cleaner,” Nic said. She’d been here plenty of times when discarded outfits had draped the furniture, when newspapers, magazines, and pizza boxes littered every flat service.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e269727"
    }
  }, [_c('span', [_vm._v("The kitchen-dining area was partly visible from where they stood. Nic walked into the kitchen. Empty. There were dirty dishes on the counter and in the sink. On the floor was a small garbage can full of coffee grounds, takeout boxes, and a blackened banana peel. When Nic accidentally nudged it with her toe, a swarm of fruit flies rose up. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e271727"
    }
  }, [_c('span', [_vm._v("She turned and walked down the short hall. In five steps she was at the end, Allison trailing silently behind her. No one was in the bedroom. Or the bathroom. The counter was covered with makeup, hair products, and jewelry. A scent lingered in the air, a light, grassy smell that Nic had always presumed was Cassidy’s natural smell, but what must be, she now realized, perfume.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e274328"
    }
  }, [_c('span', [_vm._v("“She’s not here,” Allison said. “That’s good, right? She’s not here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e274828"
    }
  }, [_c('span', [_vm._v("Nic tried to feel relief. There must be a reason Cassidy wasn’t home, a reason her door was unlocked, a reason she hadn’t answered her phone. Maybe she had gone down the hall to visit a neighbor. Although Cassidy always complained about how quiet the building was, how empty. How she could scream her head off and no one would hear.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e277328"
    }
  }, [_c('span', [_vm._v("A shiver danced across Nic’s skin. She walked back into the living room, remembering the other times the three of them had been here. Laughing. Talking. Sharing gossip and information and treats. The time they had polished off three boxes of Girl Scout cookies and two bottles of wine.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e279528"
    }
  }, [_c('span', [_vm._v("There had been other times, too, like the time she and Allison had confronted Cassidy about Rick, about what he was doing to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e280328"
    }
  }, [_c('span', [_vm._v("“Nicole?” Allison’s voice shook. “Nic?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e281028"
    }
  }, [_c('span', [_vm._v("Nic followed Allison’s pointing finger. Underneath the dining room table, half hidden in shadow, lay Cassidy’s phone—the latest, sleekest, thinnest model, all matte black and shiny silver.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e282328"
    }
  }, [_c('span', [_vm._v("Nic crouched down to look closer, not touching it. It was face up. A spiderweb of cracks spread out from one bottom corner of the screen.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e283128"
    }
  }, [_c('span', [_vm._v("Behind her, Allison said, “Maybe that’s why Cassidy’s not here. She’s probably at the phone store. That doesn’t even look usable. She dropped it, it broke, and she couldn’t call us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e284828"
    }
  }, [_c('span', [_vm._v("Nic didn’t even bother to answer her. They both knew that the keys, the purse, the unlocked door—all put the lie to Allison’s last hope.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e285828"
    }
  }, [_c('span', [_vm._v("Just past the phone, something glinted in the fading light from the dining room window. Three drops, each of them shining, oily, and thick. Blood.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e287128"
    }
  }, [_c('span', [_vm._v("When Allison saw what Nic was looking at, she caught her breath in a gasp.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e288429"
    }
  }, [_c('span', [_vm._v("Nic bent closer. The drops were nearly round. Passive spatter, meaning the drops had been formed by the force of gravity acting alone. Not high-velocity blood spatter, like that from a gunshot. Not cast off from a bloody weapon being raised again and again, flinging drops with each strike. If Cassidy had cut herself on the broken phone, it was possible that the blood had slowly dripped from her fingers until she noticed it and staunched the bleeding.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e291029"
    }
  }, [_c('span', [_vm._v("It was possible, wasn’t it?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e291729"
    }
  }, [_c('span', [_vm._v("Nic realized she was being as bad as Allison. Forcing the pieces together to make a picture of a sunny, happy scene.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e292729"
    }
  }, [_c('span', [_vm._v("She swallowed back a sudden nausea, the taste of chips and salsa burning and sour on the back of her tongue, and fought the unreasoning urge to run. How many crime scenes had she walked into? Hundreds? Her life had been in danger dozens of times. And she had never faltered. But now something told her that what had happened here was bad. Very bad indeed. And she most definitely didn’t want to see it.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e295429"
    }
  }, [_c('span', [_vm._v("Straightening up, Nic took her gun from its holster. The weight of it settled her. Her eyes swept over the floor around the blood and the broken phone, but she saw nothing else out of place. She turned her head to scan the rest of the condo again. Everything was as neat as it got at Cassidy’s. There was no trace of anyone else in any of the rooms. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e297229"
    }
  }, [_c('span', [_vm._v("But there was the broken phone.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e298029"
    }
  }, [_c('span', [_vm._v("Nic went back to the bathroom, Allison trailing. The blue shower curtain was pulled across the tub.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e299029"
    }
  }, [_c('span', [_vm._v("Was there a shadow behind it? Taking a deep breath, she pushed it back with the barrel of her Glock. The plastic curtain rings rattled. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e299829"
    }
  }, [_c('span', [_vm._v("Nothing. The white tub was empty except for a yellow rubber duck. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e300329"
    }
  }, [_c('span', [_vm._v("Nic’s breath came out in a rush, and she realized she’d been holding it.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e301429"
    }
  }, [_c('span', [_vm._v("They went back to the bedroom. The sheets and lightweight duvet were only messy on one side, mute testimony to the fact that Cassidy had been sleeping alone. Allison dropped to her knees, reminding Nic of prayers. Of prayers it felt too late to say now. Allison looked under the bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e303830"
    }
  }, [_c('span', [_vm._v("“Nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e304530"
    }
  }, [_c('span', [_vm._v("Nic reached for the closet door and then hesitated, thinking of the front door. Even though heavily handled objects didn’t usually yield good prints, the only way not to corrupt a latent print was not to touch it. Taking a tissue from her purse, she was careful to twist just the connection between the knob and the door shield.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e306430"
    }
  }, [_c('span', [_vm._v("She pulled the door open, her gun at the ready. It was stuffed full of clothes. No beige or gray for Cassidy, and very little black. Just the bright colors she loved: turquoise and orange and bright blue. With her free hand, Nic pressed on the jackets and skirts, looked underneath the hanging hems. Discarded clothes lay on top of dozens of shoes. But there was nothing that shouldn’t have been there.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e308730"
    }
  }, [_c('span', [_vm._v("She walked back into the center of the condo and stood tapping her toe, the sound "), _c('i', [_vm._v("click")]), _vm._v(", "), _c('i', [_vm._v("click")]), _vm._v(", "), _c('i', [_vm._v("click")]), _vm._v("ing on the linoleum.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e311030"
    }
  }, [_c('span', [_vm._v("Finally she spotted it.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e311730"
    }
  }, [_c('span', [_vm._v("A tiny puddle of blood was pooled on the floor in front of the sink, hidden by the lip of the cabinets. It didn’t even look dry. She took two slow steps toward it.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e313030"
    }
  }, [_c('span', [_vm._v("Allison stayed where she was, her eyes wide.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e313730"
    }
  }, [_c('span', [_vm._v("Taking a deep breath, Nic hooked her pen into the metal loop of the door and pulled.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e314730"
    }
  }, [_c('span', [_vm._v("Cassidy lay on her side, stuffed under the sink. Her body was curled around the silver U of the drain pipe. She barely fit, her knees against her chin. The front of her coral jacket was soaked in dark blood the color of the wine she liked to drink.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e316330"
    }
  }, [_c('span', [_vm._v("With unseeing blue eyes, Cassidy Shaw stared at her two friends.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49d83f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Henr_9781401686307_epub_c10_r1.vue
// module id = 87
// module chunks = 0